/* ============================================================
   MINIMA — typing effect (2026-08-06)

   Types out every [data-type-in] element: the hero tagline and any section
   subtitle that opts in. Loaded AFTER minima.js in layout/theme.liquid.

   This supersedes initHeroTyping() inside minima.js, which only ever handled
   the FIRST [data-typing] element and fired on page load. Nothing in the theme
   emits data-typing any more, so that function is inert — it is left in place
   only because the connector cannot write a 36KB minima.js without
   hand-retransmitting the whole file. FOLD THIS BACK INTO minima.js (and delete
   this file + its <script> in theme.liquid) on the next real
   `shopify theme push`.

   Two things it fixes over the old version:
   - Mid-page elements wait until they scroll into view, so the animation is
     actually seen instead of finishing above the fold.
   - A ghost copy reserves the final box, so the page never reflows mid-type.
     Without it, a subtitle typing in would shove the video grid below it down
     line by line.
   ============================================================ */
(function () {
  'use strict';

  var prefersReduced =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function typeIn(el) {
    var text = el.getAttribute('data-type-in') || '';
    if (!text) return;

    el.classList.add('typing');
    el.textContent = '';

    var ghost = document.createElement('span');
    ghost.className = 'typing__ghost';
    ghost.textContent = text;
    // The ghost must reserve room for the caret as well, not just the text.
    // Sized to the text alone, the output line (text + caret) is wider than the
    // box by exactly one caret, so the caret wraps onto a line of its own once
    // the full sentence has typed out.
    ghost.appendChild(document.createElement('span')).className = 'hero__caret';

    var out = document.createElement('span');
    out.className = 'typing__out';
    out.setAttribute('aria-hidden', 'true');

    // A text node, not innerHTML — the string is theme-editor content and must
    // never be re-parsed as markup.
    var typed = document.createTextNode('');
    var caret = document.createElement('span');
    caret.className = 'hero__caret';
    out.appendChild(typed);
    out.appendChild(caret);

    el.appendChild(ghost);
    el.appendChild(out);

    if (prefersReduced) {
      typed.data = text;
      return;
    }

    var started = false;
    function run() {
      if (started) return;
      started = true;
      var i = 0;
      setTimeout(function () {
        var timer = setInterval(function () {
          i++;
          typed.data = text.slice(0, i);
          if (i >= text.length) clearInterval(timer);
        }, 90);
      }, 500);
    }

    if (!('IntersectionObserver' in window)) {
      run();
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            run();
            io.disconnect();
            return;
          }
        }
      },
      { threshold: 0.6 }
    );
    io.observe(el);
  }

  function init() {
    var els = document.querySelectorAll('[data-type-in]');
    for (var i = 0; i < els.length; i++) typeIn(els[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // The theme editor rebuilds a section's DOM on every settings change.
  document.addEventListener('shopify:section:load', init);
})();
